import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  menuItem: {
    cursor: 'pointer',
    margin: '5px 0'
  }
})